
export const RESETDATA = 'RESETDATA';
export const GLOBAL_AUDIT_SEARCH_TYPE = 'GLOBAL_AUDIT_SEARCH_TYPE';
export const GLOBAL_AUDIT_DETAILS_TYPE = 'GLOBAL_AUDIT_DETAILS_TYPE';
export const RESET_AUDIT_DATA ="RESET_AUDIT_DATA"
export const AUDIT_LOG = 'AUDIT_LOG';
